module.exports = __webpack_public_path__ + "img/Pizzeria.6c5c8cbe.png";